// extracted by mini-css-extract-plugin
export var content = "index-module--content--7WlJI";
export var categories = "index-module--categories--cvUFd";
export var gallery_wrapper = "index-module--gallery_wrapper--qoHBC";